// extracted by mini-css-extract-plugin
module.exports = {"title":"PopinSubtitle_title__38hOD"};